import { render, staticRenderFns } from "./LmTags.vue?vue&type=template&id=1a12a920&scoped=true"
import script from "./LmTags.vue?vue&type=script&lang=js"
export * from "./LmTags.vue?vue&type=script&lang=js"
import style0 from "./LmTags.vue?vue&type=style&index=0&id=1a12a920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a12a920",
  null
  
)

export default component.exports